import React, { useEffect, useState } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"

import jwt_decode from "jwt-decode"
import Cookies from "js-cookie"

const AuthCode = () => {
  const navigate = useNavigate()

  const [searchParams, setSearchParams] = useSearchParams()

  const user_pool_domain_url = process.env.REACT_APP_USER_POOL_DOMAIN_URL
  const qued_portal_url = process.env.REACT_APP_QUED_PORTAL_URL
  const api_url = process.env.REACT_APP_API_URL

  const generateCodeVerifier = async () => {
    const array = new Uint8Array(32)
    window.crypto.getRandomValues(array)
    return btoa(String.fromCharCode.apply(null, array))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "")
  }

  const generateCodeChallenge = async codeVerifier => {
    const encoder = new TextEncoder()
    const data = encoder.encode(codeVerifier)
    const hashedVerifier = await window.crypto.subtle.digest("SHA-256", data)
    return btoa(String.fromCharCode.apply(null, new Uint8Array(hashedVerifier)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "")
  }

  useEffect(() => {
    load_all_data()
  }, [])

  const load_all_data = async () => {
    var code = searchParams.get("code")
    var client = searchParams.get("client")
    console.log(code)
    console.log(user_pool_domain_url)

    if (client) {
      localStorage.setItem("ssoClientId", client)
      const tenantLoginUrl = `${user_pool_domain_url}oauth2/authorize?client_id=${client}&response_type=code&scope=email+openid+profile&redirect_uri=https://${qued_portal_url}/auth?client=${client}`
      localStorage.setItem("tenantLoginUrl", tenantLoginUrl)
    }

    await getAccessToken(code, client)
    await get_auth_config()
  }

  const get_auth_config = async () => {
    try {
      const token = Cookies.get("idToken")
      const response = await fetch(api_url + "idp/code-grant", {
        credentials: "include",
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      if (!response.ok) {
        throw new Error("Request failed")
      }

      const jsonData = await response.json()
      console.log(jsonData)
      if (jsonData) {
        if (jsonData.idp_response && jsonData.idp_response.oidc_issuer) {
          localStorage.setItem("ssoIssuer", jsonData.idp_response.oidc_issuer)
        }
        if (jsonData.client_response && jsonData.client_response.app_client_id) {
          localStorage.setItem("ssoClientId", jsonData.client_response.app_client_id)
        }
      }
    } catch (error) {
      console.log(error)
      console.error("error occured")
    }
  }

  const getAccessToken = async (code, client) => {
    const verifier = await generateCodeVerifier()
    const challenge = await generateCodeChallenge(verifier)

    var qued_portal_url_m = qued_portal_url.endsWith('/') ? qued_portal_url : qued_portal_url + '/'

    var url =
      user_pool_domain_url +
      "oauth2/token?grant_type=authorization_code&client_id=" +
      client +
      "&redirect_uri=" +
      "https://" + qued_portal_url_m +
      "auth?client=" +
      client +
      "&code_challenge=" +
      challenge +
      "&code=" +
      code

    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      credentials: "include",
    }
    const response = await fetch(url, config)

    if (response.ok) {
      const res = await response.json()
      console.log(res)
      var decodedToken = jwt_decode(res.id_token, { complete: true })
      console.log(decodedToken)

      Cookies.set("idToken", res.id_token, {
        path: "/",
        expires: 1 / 24, // 1 hour
        secure: true,
        sameSite: "Strict",
      })

      const res1 = await fetch(api_url + 'set-cookie', {
        method: 'POST',
        credentials: 'include',
        body: res.id_token
      })
      console.log(res1)

      localStorage.setItem("email", decodedToken.email)
      localStorage.setItem("user", decodedToken.given_name)
      localStorage.setItem("tenantId", decodedToken["custom:tenant"])

      Cookies.set("email", decodedToken.email)

      navigate("/dashboard")
    } else {
      console.log(response)
    }
  }

  return <div>Loading....</div>
}

export default AuthCode
